import styled from 'styled-components';

const Container = styled.div`
  background: ${({ hasBackground }) =>
    hasBackground ? 'rgb(54, 61, 74)' : 'transparent'};
`;

export default Container;
